import { render, staticRenderFns } from "./send-collection.vue?vue&type=template&id=a766a34e&scoped=true&"
import script from "./send-collection.vue?vue&type=script&lang=js&"
export * from "./send-collection.vue?vue&type=script&lang=js&"
import style0 from "./send-collection.vue?vue&type=style&index=0&id=a766a34e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a766a34e",
  null
  
)

export default component.exports